import styled from "@emotion/styled";
import {H1, H4} from "../../../../components/typography";
import Page from "../../../../components/Page";
import {ContentBox, Section, TextContent, TitleContent, Ul} from "./PersonalInfoCollect";

export default function PersonalInfoProvide() {
    return (
        <ContentBox>
            <TitleContent><H1>개인정보 제3자 제공 동의(필수)</H1></TitleContent>
            <TextContent>
                <Section>
                    <H4 mt={10} style={{color: "#4B4B4B"}}>한국정보인증㈜는 간편인증 및 전자서명을 위한 통합인증서비스 제공을 위하여 다음과 같이 개인정보를 제공하고자 합니다. </H4>
                    <Ul>
                        <li>
                            <span>(1) 제공받는 자</span>
                            <p>- 이용자가 선택한 전자서명인증사업자</p>
                        </li>
                        <li>
                            <span>(2) 제공받는 자의 개인정보 수집 및 이용 목적</span>
                            <p>- 간편인증 및 전자서명을 제공하기 위한 이용자 식별</p>
                        </li>
                        <li>
                            <span>(3) 제공하는 개인정보 항목</span>
                            <p>- 이름, 휴대폰번호, 생년월일</p>
                        </li>
                        <li>
                            <span>(4) 제공받는 자의 개인정보 보유 및 이용기간</span>
                            <p>- 처리 목적 달성 후 즉시 파기</p>
                        </li>
                    </Ul>
                    <H4 style={{color: "#4B4B4B", paddingLeft:"20px", textIndent:"-20px"}}> ※ 이용자는 개인정보 제3자 제공 동의를 거부할 수 있습니다.{"\n"}단, 동의를 거부할 경우 통합인증서비스 이용이 제한됩니다.</H4>
                </Section>
            </TextContent>
        </ContentBox>
    );
}
